module.exports = "forum"